import { render, staticRenderFns } from "./SlideTabs.vue?vue&type=template&id=c78df78e&scoped=true&"
import script from "./SlideTabs.vue?vue&type=script&lang=js&"
export * from "./SlideTabs.vue?vue&type=script&lang=js&"
import style0 from "./SlideTabs.vue?vue&type=style&index=0&id=c78df78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78df78e",
  null
  
)

export default component.exports